import type { ReactNode, RefObject } from "react";

type RestaurantChatbotShellProps = {
  children: ReactNode;
  compact: boolean;
  open: boolean;
  widgetRef: RefObject<HTMLDivElement | null>;
};

const RestaurantChatbotShell = ({ children, compact, open, widgetRef }: RestaurantChatbotShellProps) => (
  <div
    className={`restaurant-chatbot-widget${compact ? " compact" : ""}${open ? " open" : ""}`}
    ref={widgetRef}
  >
    {children}
  </div>
);

export default RestaurantChatbotShell;
